import Input from "@Common/input"
import { PhoneNumberField } from "@Common/PhoneNumberField"
import { Checkbox } from "@mui/material"
import { isValidPhone } from "@utils"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FormInputsServiceProviderWrapper } from "./styles"
import { IFormUserManagementCentreServiceProvider } from "../.."
import { useMemo } from "react"

export default function FormInputsServiceProvider() {
	const {
		t,
		i18n: { language },
	} = useTranslation()
	const { control, watch } =
		useFormContext<IFormUserManagementCentreServiceProvider>()

	const selectedServicesWatch = watch("selectedServices", [])

	const roleList = useMemo(() => {
		return (
			(selectedServicesWatch || []).map((item) => ({
				id: item.id,
				label: language === "ar" ? item.nameAr : item.name,
				value: item.id?.toString() || "",
				isSelected: item.isSelected || false,
			})) ?? []
		)
	}, [selectedServicesWatch, language])

	return (
		<FormInputsServiceProviderWrapper>
			<Input
				label={t("UserManagement.name")}
				placeholder={t("UserManagement.name")}
				name='fullName'
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
				}}
			/>
			<Controller
				name='phoneNumber'
				control={control}
				rules={{
					required: t("COMMON.REQUIRED"),
					validate: (value) =>
						isValidPhone(value) ||
						t("UserManagement.please_enter_the_mobile_number_correctly"),
				}}
				render={({
					field: { value, onChange, onBlur },
					fieldState: { error },
				}) => (
					<PhoneNumberField
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						required
						label={t("UserManagement.phone_number")}
						placeholder={t("UserManagement.phone_number")}
						error={error?.message ? t(error.message) : undefined}
					/>
				)}
			/>
			<div className='containerCheckBox'>
				<p>{t("UserManagement.team_member_role")}</p>
				<div className='conatinerCheckbox'>
					<Controller
						name='selectedServices'
						control={control}
						defaultValue={[]}
						render={({ field: { onChange, value } }) => (
							<>
								{roleList.map((item) => {
									const isChecked = item.isSelected

									return (
										<div key={item.id} className='itemCheckbox'>
											<Checkbox
												value={item.value}
												defaultChecked={isChecked}
												onChange={() => {
													const updatedValues = value.map((val: any) =>
														val.id === item.id
															? { ...val, isSelected: !val.isSelected }
															: val
													)

													onChange(updatedValues)
												}}
											/>
											<p>{item.label}</p>
										</div>
									)
								})}
							</>
						)}
					/>
				</div>
			</div>
		</FormInputsServiceProviderWrapper>
	)
}
